/**
 * Created by pandemio on 2/7/19.
 */
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter} from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import FormCancellationSubscription from '../forms/form-cancel-subscription';

/**
 * Modal to cancel the subscription
 */
class ModalCancellationSubscription extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            disabled: props.disabled ? props.disabled : false,
            cancelAtPeriodEnd: props.cancelAtPeriodEnd ? props.cancelAtPeriodEnd : false,
            subscriptionId : props.subscriptionId ? props.subscriptionId : false,
            isEmployee: props.isEmployee ? props.isEmployee : false,
            visible: props.visible
        };
        this.toggle = this.toggle.bind(this);
    }

    componentWillReceiveProps(props)
    {
        this.setState({
            disabled: props.disabled ? props.disabled : false,
            cancelAtPeriodEnd: props.cancelAtPeriodEnd ? props.cancelAtPeriodEnd : false,
            subscriptionId : props.subscriptionId ? props.subscriptionId : false,
            isEmployee: props.isEmployee ? props.isEmployee : false,
            visible: props.visible
        });
    }
    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            visible: !this.state.visible
        });
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.visible} toggle={this.toggle}>
                    <ModalBody>
                        <FormCancellationSubscription
                            disabled={this.state.disabled}
                            cancelAtPeriodEnd={this.state.cancelAtPeriodEnd}
                            subscriptionId={this.state.subscriptionId}
                            isEmployee={this.state.isEmployee}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>
                            <Translate id="subscription-cancellation.close"/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalCancellationSubscription;